<script setup lang="ts">
import { computed } from 'vue'

type ButtonStyle = 'secondary' | true

interface Props {
  /** To render link as primary or secondary button */
  button?: ButtonStyle | null
}

const { button = null } = defineProps<Props>()

defineOptions({
  name: 'BaseLink'
})

const classes = computed(() => {
  if (button) {
    let buttonClasses =
      'h-10 inline-flex items-center px-4 text-sm font-medium hover:shadow-sm'

    if (button === 'secondary') {
      buttonClasses += ' border border-primary text-primary'
    } else {
      buttonClasses += ' bg-primary text-white'
    }

    return buttonClasses
  }

  return 'text-primary underline inline-block'
})
</script>

<template>
  <a :class="classes">
    <slot />
  </a>
</template>
